<template>
    <v-card min-width="21vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>Edit your visibility</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 pt-7">
            <v-form v-model="valid">
                <v-container fluid>
                    <v-row class="mb-n4 mt-n2">
                        <v-col>
                            <v-select @change="changeVisibilityImplicationsMessage" :items="visibilities" label="Visibility for your journal" v-model="selectedVisibility" :rules="visibilityRule" outlined/>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.selectedVisibility !== ''">
                        <p class="mb-5">With <b>{{ this.selectedVisibility }}</b> visibility,<br>
                            {{ visibilityImplicationsMessage }}</p>
                    </v-row>
                    <div class="mb-3 mt-2">
                        <v-btn @click="closeWindow">Cancel</v-btn>
                        <v-btn class="ml-5" @click="editVisibility">Save and Close</v-btn>
                    </div>
                </v-container>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../../repositories/auth';
    import { mapMutations } from 'vuex';
    export default {
        name: "EditVisibility",
        data() {
            return {
                visibilities: [
                    'Public',
                    'Private',
                    'Hidden'
                ],
                valid: false,
                initialVisibility: '',
                selectedVisibility: '',
                visibilityImplicationsMessage: '',

                // Rules
                visibilityRule: [
                    v => !!v || 'Visibility is mandatory',
                ],
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.initialVisibility = this.$store.state.user.details.profileStatus;
            },
            changeVisibilityImplicationsMessage() {
                switch (this.selectedVisibility) {
                    case 'Public':
                        this.visibilityImplicationsMessage = 'everyone can see your journal/stats via your username.';
                        break;
                    case 'Private':
                        this.visibilityImplicationsMessage = 'people must request permission to see your journal/stats.';
                        break;
                    case 'Hidden':
                        this.visibilityImplicationsMessage = 'nobody can search for your journal/stats. Fully hidden.';
                        break;
                }
            },
            ...mapMutations(['setNewVisibility']),
            editVisibility() {
                if(this.valid) {
                    if(this.selectedVisibility !== this.initialVisibility) {
                        let visibility = {
                            newVisibility: this.selectedVisibility.toUpperCase()
                        };
                        Repository.editVisibility(visibility).then((response) => {
                            if(response.status < 400 && response.data) {
                                this.setNewVisibility(visibility.newVisibility);
                                this.closeWindow();
                            }
                        });
                    }
                } else
                    alert('Visibility is mandatory');
            },
            closeWindow() {
                this.$emit('closeWindow');
            },
        }
    }
</script>

<style scoped>

</style>
